import {branchLoading, hideBranches} from '@opportunus-lib-js/lazy-load/amp-branch-leaflet-lazy-tool.js';

initMobileBranchPreview();

export function initMobileBranchPreview()
{
    let branchesMobile = document.getElementsByClassName('branches-mobile');

    if(branchesMobile.length > 0)
    {
        branchesMobile = branchesMobile[0];

        const branches = document.getElementsByClassName('branches');

        if(branches.length > 0)
        {
            let branch = branches[0];
            let tooltip = branch.getElementsByClassName('tooltip');
            let content = branch.getElementsByClassName('content');

            if(content.length > 0)
            {
                content = content[0];
            }

            if(content && tooltip.length > 0)
            {
                let ajaxUrl = branchesMobile.getAttribute('data-link');

                branchesMobile.addEventListener('click', () => {
                    content.setAttribute('data-init', 0);
                    hideBranches(branches);
                    branchLoading(tooltip, content, ajaxUrl); });
            }
        }
    }
}